import {
    Box,
    Button,
    Card,
    Checkbox,
    Container,
    Fab,
    Grid,
    IconButton,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Toolbar,
    Tooltip,
    Typography,
    alpha,
} from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import PrintsQRCodeModal from 'src/component-project/PrintsQRCodeModal';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ComboBox from 'src/components/Input/ComboBox';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify';
import Loader from 'src/components/loader/loader';
import { UserListToolbar } from 'src/sections/@dashboard/user';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

const PrintsQRCode = () => {
    const { t } = useTranslation();

    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getListDevices(), 1000));

    const [groupDevice, setGroupDevice] = useState({ group_nm: t('all'), id: 0 });

    const [listDevices, setListDevices] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);

    const [total, setTotal] = useState(0);
    const lastID = useRef(0);

    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [workStatusCount, setworkStatusCount] = useState(0);

    const [visiblePrints, setVisiblePrints] = useState(false);

    const [listGroupDevices, setListGroupDevices] = useState([]);
    const [getFlagsGroup, setGetFlagsGroup] = useState(false);
    const getRefGroup = useRef(false);
    // const [valueOptions, setValueOptions] = useState({});
    const [needGetDataNext, setNeedGetDataNext] = useState(false);

    useEffect(() => {
        setPage(0);
        if (groupDevice?.id !== 0) {
            setSelected([]);
        }
        setTimeout(() => {
            getListDevices();
        }, 600);
    }, [groupDevice]);

    useEffect(() => {
        setTimeout(() => {
            getListGroupDevices();
        }, 600);
    }, []);

    const getListDevices = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const Inval = [(searchValueDeboun?.current || '')?.toUpperCase(), groupDevice?.id || 0, 99999];
        sendRequest(serviceList.getListDeviceBase, Inval, getDataResult, true, timeOutFunct, 40000);
    }, [groupDevice]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if (message['proc_status'] === 0) {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('success: ', message.proc_data.rows[0].o_1, message.proc_data.rowTotal);
            setListDevices(message.proc_data.rows[0].o_1);
            setTotal(message.proc_data.rowTotal);
            lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
            if (groupDevice?.id !== 0 && message.proc_data.rowTotal < listDevices.length) {
                setNeedGetDataNext(true);
            }
        }
    };

    const getDataNext = () => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [(searchValueDeboun?.current || '')?.toUpperCase(), groupDevice?.id || 0, lastID.current];
        sendRequest(serviceList.getListDeviceBase, InVal, getDataResultNext, true, timeOutFunct, 40000);
    };

    const getDataResultNext = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('success next data: ', message.proc_data.rows[0].o_1, message.proc_data.rowTotal);
            const dataNew = [...listDevices, ...message.proc_data.rows[0].o_1];
            setListDevices([...listDevices, ...message.proc_data.rows[0].o_1]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
                // arrFillters.current = message.proc_data.rows[0].o_1;
                if (groupDevice?.id !== 0 && dataNew.length < message.proc_data.rowTotal) {
                    setNeedGetDataNext(true);
                }
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const getListGroupDevices = useCallback(() => {
        if (getRefGroup.current) {
            return;
        }
        getRefGroup.current = true;
        setGetFlagsGroup(true);
        const Inval = [];
        sendRequest(
            serviceList.getAllgroup_devices,
            Inval,
            getDataResultGroupDevices,
            true,
            timeOutFunctGroupDevices,
            40000
        );
    }, []);

    const getDataResultGroupDevices = (reqInfoMap, message) => {
        getRefGroup.current = false;
        setGetFlagsGroup(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('success: ', message.proc_data.rows[0].o_1, message.proc_data.rowTotal);
            setListGroupDevices([{ group_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
        }
    };

    const timeOutFunctGroupDevices = (reqInfo) => {
        getRefGroup.current = false;
        setGetFlagsGroup(false);
        toast.error(t('error.time_out'));
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };

    const headCells = [
        {
            id: 'stt',
            numeric: false,
            disablePadding: true,
            label: t('stt'),
        },
        {
            id: 'code_device',
            numeric: false,
            disablePadding: true,
            label: t('code_device'),
        },
        {
            id: 'name_device',
            numeric: false,
            disablePadding: false,
            label: t('name_device'),
        },
        {
            id: 'group_devices',
            numeric: false,
            disablePadding: false,
            label: t('group_devices'),
        },
    ];

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = listDevices.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    // const handleSelectAllClick = (event) => {
    //     console.log('checked', event.target.checked)
    //     const visiblePageRows = listDevices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //     if (event.target.checked) {
    //         const filteredVisiblePageRows = visiblePageRows.filter(row => !selected.some(selectedRow => selectedRow.id === row.id));
    //         const newSelected = [...selected, ...filteredVisiblePageRows];
    //         // const newSelected = [...selected, ...visiblePageRows];
    //         setSelected(newSelected);
    //         return;
    //     }
    //     setSelected([]);
    // };

    const handleClick = (event, row) => {
        const selectedIndex = selected.indexOf(row);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    // const isSelected = (row) => selected.length > 0 && selected.filter((item) => item.id === row).id !== -1
    const isSelected = (id) => selected.some((item) => item.id === id);

    const visibleRows = listDevices
        .sort((a, b) => a.device_cd.localeCompare(b.device_cd))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    useEffect(() => {
        if (needGetDataNext) {
            getDataNext();
            setNeedGetDataNext(false);
        }
    }, [needGetDataNext]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setNeedGetDataNext(true);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Helmet>
                <title> {t('print_qr')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('print_qr')}
                    </Typography>
                </Stack>
                <Breadcrumb paths={[{ label: t('print_qr'), url: '#', navigate: false }]} />

                {selected.length > 0 && (
                    <PrintsQRCodeModal visible={visiblePrints} setVisible={setVisiblePrints} data={selected} />
                )}

                <Stack direction="row" alignItems="center" justifyContent="center" flexWrap={'wrap'}>
                    <Card>
                        <Box sx={{ width: '100%' }}>
                            <Paper sx={{ width: '100%', mb: 2 }}>
                                <Grid container spacing={2} sx={{ marginTop: '0.5' }}>
                                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                                        <UserListToolbar getValue={searchValue} />
                                    </Grid>
                                    <Grid item xl={12} md={6} sm={6} style={{ margin: 'auto', paddingRight: '25px' }}>
                                        <ComboBox
                                            label={t('group_devices')}
                                            selectOption={listGroupDevices}
                                            displayLabel="group_nm"
                                            getValue={setGroupDevice}
                                            valueSelect={groupDevice}
                                            sizeCbb="lg"
                                        />
                                    </Grid>
                                </Grid>
                                {selected.length > 0 && (
                                    <Toolbar
                                        sx={{
                                            pl: { sm: 2 },
                                            pr: { xs: 1, sm: 1 },
                                            ...(selected.length > 0 && {
                                                bgcolor: (theme) =>
                                                    alpha(
                                                        theme.palette.primary.main,
                                                        theme.palette.action.activatedOpacity
                                                    ),
                                            }),
                                        }}
                                    >
                                        {selected.length > 0 ? (
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                mb={1}
                                                width={'100%'}
                                            >
                                                <Typography
                                                    sx={{ flex: '1 1 100%' }}
                                                    color="inherit"
                                                    variant="subtitle1"
                                                    component="div"
                                                >
                                                    {selected.length + ' ' + t('selected')}
                                                </Typography>
                                                <Button
                                                    sx={{ width: '30%' }}
                                                    variant="contained"
                                                    startIcon={<Iconify icon="ic:outline-local-printshop" />}
                                                    onClick={() => setVisiblePrints(true)}
                                                >
                                                    {t('print')}
                                                </Button>
                                            </Stack>
                                        ) : (
                                            <Typography
                                                sx={{ flex: '1 1 100%' }}
                                                variant="h6"
                                                id="tableTitle"
                                                component="div"
                                            >
                                                Danh sách thiết bị
                                            </Typography>
                                        )}
                                        {/* {selected.length > 0 && (
                                            <Button variant="contained" startIcon={<Iconify icon="ic:outline-local-printshop" />} onClick={() => setVisiblePrints(true)}>
                                                {t('print')}
                                            </Button>
                                        )} */}
                                    </Toolbar>
                                )}
                                <Loader loading={getFlags} />
                                <TablePagination
                                    rowsPerPageOptions={[50]}
                                    component="div"
                                    count={searchValueDeboun.current ? listDevices.length : total}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                                <TableContainer>
                                    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'small'}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    {searchValueDeboun.current || groupDevice?.id !== 0 ? (
                                                        <Checkbox
                                                            indeterminate={
                                                                selected.length > 0 &&
                                                                selected.length < listDevices.length
                                                            }
                                                            checked={
                                                                selected.length > 0 &&
                                                                selected.length === listDevices.length
                                                            }
                                                            onChange={handleSelectAllClick}
                                                            inputProps={{
                                                                'aria-label': 'select all desserts',
                                                            }}
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                </TableCell>
                                                {headCells.map((headCell) => (
                                                    <TableCell
                                                        key={headCell.id}
                                                        align={headCell.numeric ? 'right' : 'left'}
                                                        padding={headCell.disablePadding ? 'none' : 'normal'}
                                                    >
                                                        {headCell.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {visibleRows.map((row, index) => {
                                                const isItemSelected = isSelected(row.id);
                                                const labelId = `enhanced-table-checkbox-${row.id}`;
                                                return (
                                                    <TableRow
                                                        hover
                                                        onClick={(event) => handleClick(event, row)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={row.id}
                                                        selected={isItemSelected}
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                checked={isItemSelected}
                                                                inputProps={{
                                                                    'aria-labelledby': labelId,
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">{index + 1}</TableCell>
                                                        <TableCell
                                                            component="th"
                                                            id={labelId}
                                                            scope="row"
                                                            padding="none"
                                                        >
                                                            {row.device_cd}
                                                        </TableCell>
                                                        <TableCell align="left">{row.device_nm}</TableCell>
                                                        <TableCell align="left">
                                                            {glb_sv.convertMultipleLanguages(row.group_nm)}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                    {visibleRows.length === 0 && <EmtyData />}
                                </TableContainer>
                            </Paper>
                        </Box>
                    </Card>
                </Stack>
            </Container>
        </>
    );
};

export default PrintsQRCode;
